module.exports = __webpack_public_path__ + "static/media/pinkTheme-boy.896e8983.svg";